import { h } from '@stencil/core';

export const AcceptedMessage = () => (
  <div class="font-open-sans text-sm">
    <span>
      What happens next:
      <br />A dedicated Kelley Blue Book representative will soon be in touch to schedule a virtual vehicle inspection. They’ll confirm your ownership details and provide all the
      necessary documents. Get ready for an exciting and seamless experience!
    </span>
  </div>
);

export const LegalText = () => (
  <span class="font-open-sans text-clrs-charcoal">
    Inspection required. If the info you provide about the vehicle differs from the inspection, the Offer amount may be decreased.
  </span>
);
